module.exports = __webpack_public_path__ + "img/gameit.9c5b0529.png";